import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import '../../assets/styles/Login.css';
import { loginSuccessReset, setTokenExpiredFalse, userLoggingin } from '../../actions/loginActions';
import { Input } from '../common';
import { isTokenExpired, validateEmail } from '../../utils/validators';
import { setRegistrationMessage } from '../../actions/RegistrationActions';
import { resetPasswordSuccess } from '../../actions/ResetPasswordActions';
import Routes from '../../constants/routes';
import Checkbox from '../common/Checkbox';
import { getUser } from '../../utils/utils';

class LoginPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: {
                value: null,
                error: null,
            },
            password: {
                value: null,
                error: null,
            },
            rememberMe: false,
        };

        this.handleLogin = this.handleLogin.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
    }

    componentDidMount() {
        document.title = 'Log in » Askimam';
    }

    componentWillUnmount() {
        this.props.setTokenExpireFalse();
        this.props.showRegisteredMessage();
        this.props.showResetMessage();
        this.props.resetLoginSuccess();
    }

    static getDerivedStateFromProps(props, state) {
        if (props.userTokenReducer.loginSuccess === false && !state.failedAttempt) {
            return {
                ...state,
                password: {
                    value: null,
                    error: null,
                },
            };
        }
        return state;
    }

    toggleCheckbox = (event) => {
        const name = event.target.name;

        this.setState(prevState => ({
            [name]: !prevState[name],
        }));
    };

    handleValidation(event, error) {
        event.preventDefault();
        const name = event.target.name;
        const prevState = this.state[name];
        this.setState({
            [name]: {
                ...prevState,
                error,
            },
        });
    }

    handleLogin() {
        const email = this.state.email.value;
        const password = this.state.password.value;
        const { history } = this.props;

        if (email && password) {
            this.props.userLogin(email, password, this.state.rememberMe, history);
        }
    }

    handleChange(e) {
        e.preventDefault();
        if (this.props.userTokenReducer.loginSuccess === false) {
            this.props.resetLoginSuccess();
        }

        const name = e.target.name;
        const prevState = this.state[name];
        this.setState({
            [name]: {
                ...prevState,
                value: e.target.value,
            },
        });
    }

    handleRegisterLink = () => {
        this.props.history.push(Routes.register);
        window.scrollTo(0, 0);
    };

    showErrorMessage = () => {
        if (this.props.userTokenReducer.loginSuccess === false) {
            return (
                <div className="authMessage">
                    The User could not be Logged in. Please check if correct credentials are being entered!
                </div>
            );
        }
        if (this.props.userTokenReducer.tokenExpired) {
            return (
                <div className="authMessage">
                    The authentication token has expired, kindly login again.
                </div>
            );
        }
        if (this.props.registeredReducer.registered) {
            return (
                <div className="flashMessage">
                    Kindly check your email to activate your account.
                </div>
            );
        }
        if (this.props.resetReducer.reset) {
            return (
                <div className="flashMessage">
                    Password has been reset. Kindly login with latest credentials.
                </div>
            );
        }
        return false;
    }

    render() {
        const loggedInUser = getUser();
        if (loggedInUser && !isTokenExpired(loggedInUser)) {
            return <Redirect to="/" />;
        }
        const { email, password } = this.state;

        return (
            <div className="section">
                <h2>login | askimam</h2>
                <div className="signin">
                    <div className="container custom-container">
                        <div className="login-header">
                            <p className="title text-center">Welcome to askimam.org</p>
                            <span className="description">Please login to submit your queries.</span>
                        </div>
                        <div className="login-body">
                            {this.showErrorMessage()}
                            <h6 className="user-login">user login</h6>
                            <Input
                                isRequired
                                type="text"
                                placeholder="Username/Email"
                                value={email.value}
                                maxLength={60}
                                className="form-control login-input"
                                handleChange={this.handleChange}
                                onBlur={e => this.handleValidation(e, validateEmail(email.value))}
                                error={email.error}
                                name="email"
                                icon="fa-user"
                            />
                            <Input
                                isRequired
                                type="password"
                                placeholder="Password"
                                value={password.value}
                                maxLength={60}
                                className="form-control login-input"
                                handleChange={this.handleChange}
                                error={password.error}
                                name="password"
                                icon="fa-lock"
                            />
                            <div className="links-holder">
                                <div className="remember-me-checkbox">
                                    <Checkbox
                                        label="Remember me"
                                        type="checkbox"
                                        name="rememberMe"
                                        isChecked={this.state.rememberMe}
                                        handleChange={this.toggleCheckbox}
                                    />
                                </div>
                                {' '}
                                <Link to={Routes.forgotPassword} className="forgot-password">Forgot password?</Link>
                            </div>
                            <div className="button-wrapper">
                                <button
                                    className="submit button login-button"
                                    type="submit"
                                    onClick={this.handleLogin}
                                >
                                    Login
                                </button>
                            </div>
                            <p className="register-here">
                                Need new account?
                                <button type="button" onClick={this.handleRegisterLink} className="register-here-link"> Register here</button>
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

LoginPage.propTypes = {
    history: PropTypes.object.isRequired,
    userTokenReducer: PropTypes.object.isRequired,
    registeredReducer: PropTypes.object.isRequired,
    resetReducer: PropTypes.object.isRequired,
    setTokenExpireFalse: PropTypes.func.isRequired,
    showRegisteredMessage: PropTypes.func.isRequired,
    showResetMessage: PropTypes.func.isRequired,
    resetLoginSuccess: PropTypes.func.isRequired,
    userLogin: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    userTokenReducer: state.loginReducer,
    registeredReducer: state.registerMessageReducer,
    resetReducer: state.resetPasswordReducer,
});

const mapDispatchToProps = dispatch => ({
    showRegisteredMessage: () => dispatch(setRegistrationMessage(false)),
    showResetMessage: () => dispatch(resetPasswordSuccess(false)),
    resetLoginSuccess: () => dispatch(loginSuccessReset),
    userLogin: (email, password, rememberMe, history) => dispatch(userLoggingin(email, password, rememberMe, history)),
    setTokenExpireFalse: () => dispatch(setTokenExpiredFalse),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginPage));
